import SiteMaintenancePres from 'src/ui/features/Maintenance/presentational/SiteMaintenancePres';
import React from 'react';
import { connect } from 'react-redux';
import { updateBodyClass } from 'src/helpers';
import { BODY_CLASSES } from 'src/constants/constants.js';

export class SiteMaintenance extends React.Component {
  componentWillMount() {
    updateBodyClass(BODY_CLASSES.SITE_MAINTENANCE);
  }

  componentWillUnmount() {
    updateBodyClass(BODY_CLASSES.SITE_MAINTENANCE);
  }

  render() {
    return <SiteMaintenancePres {...this.props} />;
  }
}

export const mapStateToProps = state => ({
  browser: state.browser,
});

export default connect(mapStateToProps)(SiteMaintenance);
